<template>
  <div>
    <div class="search-content">

      <el-col :span="24" class="toobar">
        <el-row>
          <el-col :span="3">
            <el-input placeholder="请选择商品" v-model="seedname" size="mini" clearable @click.native="showGoodDetailSel"
                      @clear="clearSeedCode">
            </el-input>
          </el-col>
          <el-col :span="21">
            <el-select v-model="cangkucode" @change="bindGrid" filterable style="width: 150px" size="mini" >
              <el-option v-for="item in jxcstoreData" :key="item.cangkucode"
                         :label="item.cangkuname"
                         :value="item.cangkucode">
              </el-option>
            </el-select>
            <el-input style="width:120px;" size="mini"
                      placeholder="输入单号"
                      prefix-icon="el-icon-search"
                      v-model="searchdata" clearable>
            </el-input>
            <el-date-picker style="width:110px;"
              v-model="date" size="mini"
              type="month"
              v-if="radio2=='0'||radio2=='1'||radio2=='3'" :clearable="false"
              placeholder="选择日期">
            </el-date-picker>
            <el-button type="primary" v-model="searchdata" icon="el-icon-search" @click="bindGrid(false)" size="mini" >搜索</el-button>
            <el-button type="warning" v-on:click="excelPort" size="mini" v-if="radio2=='2'||radio2=='1'||radio2=='3'">导出</el-button>
            <input type="file" ref="fileupload1" style="display: none;" @change="change1($event)"/>
            <el-dropdown style="margin-left: 20px" @command="handleDropCommand" v-if="!bimanage">
              <el-button type="warning" icon="el-icon-edit"  size="mini">
                正式库转入
              </el-button>
              <el-dropdown-menu slot="dropdown" style="font-size: larger">
                <el-dropdown-item command="lens"> 镜 片 </el-dropdown-item>
                <el-dropdown-item command="frame"> 镜 架 </el-dropdown-item>
                <el-dropdown-item command="other"> 其 他 </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-button type="success" v-on:click="addstoragebad(1)" size="mini" v-if="!bimanage">供应商多发（镜片）</el-button>
            <!--<el-button type="success" v-on:click="addstoragebadFrame(1)"  size="mini">供应商多发（镜架）</el-button>-->
            <!--<el-button type="warning" v-on:click="addstoragebad(2)"  size="mini">正式库转入（镜片）</el-button>-->
            <!--<el-button type="warning" v-on:click="addstoragebadFrame(2)"  size="mini">正式库转入（镜架）</el-button>-->
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
          <el-radio-group v-model="radio2" size="mini" @change="bindGrid(false)" style="margin-top: 10px">
            <!--<el-radio-button :label="'1'" :key="'1'">加工报损</el-radio-button>-->
            <el-radio-button :label="'2'" :key="'2'">待处理</el-radio-button>
            <el-radio-button :label="'1'" :key="'1'">入库单</el-radio-button>
            <el-radio-button :label="'3'" :key="'3'">出库单</el-radio-button>
            <el-radio-button :label="'0'" :key="'0'">出库汇总</el-radio-button>
          </el-radio-group>
          </el-col>
          <el-col :span="12">
          <el-button size="mini"  v-if="radio2==2&&cangkucode&&!bimanage" style="float: right;margin-right: 240px;margin-top: 10px"
                     @click="handleEditBatch()">批量处理选中
          </el-button>
          </el-col>
        </el-row>
      </el-col>
    </div>

    <el-table
      :data="tableData"
      :height="tableHeight(115)"
      show-summary
      :summary-method="getSummariesOrder"
      size="mini"
      stripe
      border
      v-if="radio2==1||radio2==3"
      style="width: 100%;">
      <el-table-column
        width="50"
        label="序号"
        align="center">
        <template slot-scope="scope">
          {{1+scope.$index}}
        </template>
      </el-table-column>
      <el-table-column
        prop="erpserial"
        label="单号"
        header-align="center"
        :show-overflow-tooltip="true"
        align="left"
        width="130">
        <template slot-scope="scope">
                  <span @click="lookdingdan(scope.row.erpserial)" style="cursor: pointer;font-weight:bold">
                    {{ scope.row.erpserial}}
                  </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="statusname"
        label="状态"
        align="center"
        header-align="center"
        width="80">
        <template slot-scope="scope">
          <span style="color: red" v-if="scope.row.status==1"><b>待审核</b></span>
          <span style="color: #00BDFF" v-else-if="scope.row.status==-1"><b>驳回</b></span>
          <span v-else>已生效</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="accdate"
        label="日期"
        header-align="center"
        :show-overflow-tooltip="true"
        align="left"
        width="140">
      </el-table-column>
      <el-table-column
        prop="cangkuname"
        label="仓库"
        header-align="center"
        :show-overflow-tooltip="true"
        align="left"
        width="140">
      </el-table-column>
      <el-table-column
        prop="categoryname" width="100"
        label="品牌"
        header-align="center"
        :show-overflow-tooltip="true"
        align="left">
      </el-table-column>
      <el-table-column
        prop="seedname"
        label="名称"
        header-align="center"  width="200"
        :show-overflow-tooltip="true"
        align="left">
      </el-table-column>
      <el-table-column
        prop="seedcode"
        label="编码"
        header-align="center"
        width="110"
        :show-overflow-tooltip="true"
        align="left">
      </el-table-column>
      <el-table-column
        prop="packagesize"
        label="规格"
        align="left" :show-overflow-tooltip="true"
        header-align="center" width="150">
      </el-table-column>
      <el-table-column
        prop="totalnumber"
        label="数量"
        header-align="center"
        align="center"
        width="70">
      </el-table-column>
      <template v-if="radio2==1">
      <el-table-column
        prop="handlenumber"
        label="已处理数"
        header-align="center"
        align="center"
        width="70">
      </el-table-column>
        <el-table-column
          prop="waitnumber"
          label="未处理数"
          header-align="center"
          align="center"
          width="70">
        </el-table-column>
      <el-table-column
        prop="ordernum"
        label="销售单号"
        header-align="center" :show-overflow-tooltip="true"
        align="left"
        width="130">
        <template slot-scope="scope">
                  <span @click="lookdingdan(scope.row.ordernum)" style="cursor: pointer;font-weight:bold">
                    {{ scope.row.ordernum}}
                  </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="buyordernum"
        label="采购单号"
        header-align="center" :show-overflow-tooltip="true"
        align="left"
        width="130">
      </el-table-column>
      <el-table-column
      prop="ordername"
      label="原因"
      align="left"
      header-align="center"
      width="100">
    </el-table-column>
      <el-table-column
        prop="remark"
        label="备注" :show-overflow-tooltip="true"
        align="left"
        header-align="center"
        width="200">
      </el-table-column>
      <el-table-column
        prop="customername"
        label="责任人" :show-overflow-tooltip="true"
        header-align="center"
        align="center"
        width="90" >
      </el-table-column>
      </template>
      <template v-else>
        <el-table-column
          prop="handlemode"
          label="出库方式"
          header-align="center"
          align="center"
          width="100">
        </el-table-column>
        <el-table-column
          prop="buyordernum"
          label="采购退货单号"
          header-align="center" :show-overflow-tooltip="true"
          align="left"
          width="130">
        </el-table-column>
        <el-table-column
          prop="customername"
          label="退回供应商"
          header-align="center" :show-overflow-tooltip="true"
          align="left"
          width="120">
        </el-table-column>
        <el-table-column
          prop="remark"
          label="出库备注" :show-overflow-tooltip="true"
          align="left"
          header-align="center"
          width="200">
        </el-table-column>
        <el-table-column
          prop="ordernum"
          label="入库单号"
          header-align="center"
          :show-overflow-tooltip="true"
          align="left"
          width="130">
          <template slot-scope="scope">
                  <span @click="lookdingdan(scope.row.ordernum)" style="cursor: pointer;font-weight:bold">
                    {{ scope.row.ordernum}}
                  </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="inaccdate"
          label="入库日期"
          header-align="center"
          :show-overflow-tooltip="true"
          align="left"
          width="140">
        </el-table-column>
        <el-table-column
          prop="inordernum"
          label="原销售单号"
          header-align="center" :show-overflow-tooltip="true"
          align="left"
          width="130">
          <template slot-scope="scope">
                  <span @click="lookdingdan(scope.row.inordernum)" style="cursor: pointer;font-weight:bold">
                    {{ scope.row.inordernum}}
                  </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="inbuyordernum"
          label="原采购单号"
          header-align="center" :show-overflow-tooltip="true"
          align="left"
          width="130">
        </el-table-column>
        <el-table-column
          prop="inordername"
          label="入库原因"
          align="left"
          header-align="center"
          width="90">
        </el-table-column>
        <el-table-column
          prop="inremark"
          label="入库备注" :show-overflow-tooltip="true"
          align="left"
          header-align="center"
          width="200">
        </el-table-column>
      </template>
      <el-table-column
        prop="uname"
        label="录入人" :show-overflow-tooltip="true"
        header-align="center"
        align="center"
        width="90" >
      </el-table-column>
    </el-table>
    <BaoSunDetail ref="BaoSunDetail" @bindGrid="bindGrid"></BaoSunDetail>
    <el-table
      :data="tableData"
      :height="eltableheight"
      size="mini" v-if="radio2==0||radio2==2"
      stripe
      border @selection-change="handleSelectionChange"
      show-summary
      :summary-method="getSummaries"
      style="width: 100%;">
      <el-table-column
        type="selection"
        width="55">
      </el-table-column>
      <el-table-column
        width="50"
        label="序号"
        align="center">
        <template slot-scope="scope">
          {{1+scope.$index}}
        </template>
      </el-table-column>
      <el-table-column
        prop="cangkuname"
        label="仓库"
        header-align="center"
        :show-overflow-tooltip="true"
        align="left"
        width="140">
      </el-table-column>
      <el-table-column
        prop="categoryname" width="160"
        label="品牌"
        header-align="center"
        :show-overflow-tooltip="true"
        align="left">
      </el-table-column>
      <el-table-column
        prop="seedname"
        label="名称" v-if="radio2==0"
        header-align="center"
        :show-overflow-tooltip="true"
        align="left">
      </el-table-column>
      <el-table-column
        prop="seedcode"
        label="编码" v-if="radio2==0"
        header-align="center"
        width="110"
        :show-overflow-tooltip="true"
        align="left">
      </el-table-column>
      <el-table-column
        prop="duofa" v-if="radio2==2"
        label="供应商多发"
        header-align="center"
        align="center"
        width="100" >
      </el-table-column>
      <el-table-column
        prop="tuihuo" v-if="radio2==2"
        label="销售退货"
        header-align="center"
        align="center"
        width="100" >
      </el-table-column>
      <el-table-column
        prop="yanguang" v-if="radio2==2"
        label="验光原因"
        header-align="center"
        align="center"
        width="100" >
      </el-table-column>
      <el-table-column
        prop="guike" v-if="radio2==2"
        label="顾客原因"
        header-align="center"
        align="center"
        width="100" >
      </el-table-column>
      <el-table-column
        prop="zhiliang" v-if="radio2==2"
        label="质量问题"
        header-align="center"
        align="center"
        width="100" >
      </el-table-column>
      <el-table-column
        prop="jiagongbaosun" v-if="radio2==2"
        label="加工损坏"
        header-align="center"
        align="center"
        width="100" >
      </el-table-column>
      <el-table-column
        prop="guoqi" v-if="radio2==2"
        label="商品过期"
        header-align="center"
        align="center"
        width="100" >
      </el-table-column>
      <el-table-column
        prop="zhuanru" v-if="radio2==2"
        label="其他原因"
        header-align="center"
        align="center"
        width="100" >
      </el-table-column>
      <el-table-column
        prop="ruzhnegshiku" v-if="radio2==0"
        label="入正式库"
        header-align="center"
        align="center"
        width="100" >
      </el-table-column>
      <el-table-column
        prop="yuanpian" v-if="radio2==0"
        label="原片使用"
        header-align="center"
        align="center"
        width="100" >
      </el-table-column>
      <el-table-column
        prop="sunhao"  v-if="radio2==0"
        label="损耗"
        header-align="center"
        align="center"
        width="100" >
      </el-table-column>
      <el-table-column
        prop="thgys"  v-if="radio2==0"
        label="退供应商"
        header-align="center"
        align="center"
        width="100" >
      </el-table-column>
      <el-table-column
        prop="move"  v-if="radio2==0"
        label="转其他仓库"
        header-align="center"
        align="center"
        width="100" >
      </el-table-column>
      <el-table-column label="操作" align="center" width="80" >
        <template slot-scope="scope">
          <el-button size="mini"  v-if="radio2==2"
                     @click="handleEdit(scope.row)">处理
          </el-button>
          <el-button
            size="mini" v-if="radio2==0"
            @click="lookorder(scope.row)">查看
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <CstagreementEdit ref="DataContactEdit" @bindGrid="bindGrid"></CstagreementEdit>
    <StorageBadEdit ref="StorageBadEdit" @bindGrid="bindGrid"></StorageBadEdit>
    <StorageBadDetail ref="StorageBadDetail" @bindGrid="bindGrid"></StorageBadDetail>
    <AddStorageBad ref="AddStorageBad" @bindGrid="bindGrid"></AddStorageBad>
    <AddStorageBadFrame ref="AddStorageBadFrame" @bindGrid="bindGrid"></AddStorageBadFrame>
    <AddStorageBadOther ref="AddStorageBadOther" @bindGrid="bindGrid"></AddStorageBadOther>
    <JxcgooddetailSel ref="JxcgooddetailSel" @afterSelectCode="afterSelectCode"></JxcgooddetailSel>
    <StorageBadOut ref="StorageBadOut1"></StorageBadOut>
  </div>

</template>

<script>
  import {independentDept} from '@/api/set/dept';
  import {brokengoodslist, badpartsimport, badpartslist,} from '@/api/set/warehouse'
  import StorageBadDetail from './StorageBadDetail';
  import StorageBadEdit from './StorageBadEdit';
  import AddStorageBad from './AddStorageBad';
  import CstagreementEdit from '@/components/testorder/cstagreement/CstagreementEdit';
  import AddStorageBadFrame from './AddStorageBadFrame'
  import AddStorageBadOther from './AddStorageBadOther'
  import {cusandptbyind} from '@/api/set/jxcstore';
  import {updatebadparts,badpartscount,completedcount,outorder,inorder} from '@/api/set/jxcstoreformdetail';
  import JxcgooddetailSel from '../set/jxcgooddetail/JxcgooddetailSel'
  import BaoSunDetail from '../testorder/cstagreement/BaoSunDetail'
  import StorageBadOut from './StorageBadOut'

  export default {
    name: 'StorageBad',
    data() {
      return {
        msg:'坏件库管理主页',
        userInfoModel: {},
        tablecolumns: [],
        eltableheight:300,
        dialogFormVisible: false,
        searchdata: "",
        bimanage:false,
        loading: true,
        independentserial: "",
        jxcstoreData:[],
        tableData: [],
        cangkucode: '',
        radio2: 2,
        handlemode: '',
        seedname: '',
        seedcode: '',
        date: '',
        multipleSelection:[],
      }
    },
    props: {
      cangkucodes: {type: Array, default: () => []},
      cangkuname: {default: ""},
    },
    methods: {
      excelPort() {
        let data = []
        let header1 = []
        let column1 = []
        if (this.radio2 == 2) {//待处理状态的商品
          badpartslist({
            formtype: 78,
            seedcode: '',
            categorycode: '',
            cangkucode: this.cangkucode,
            status: 20,
            customerserial: ''
          }).then(response => {
            var excelData = response.data.obj;
            for(let i in excelData){
              try {
                if(excelData[i].packagesize){
                  var jsP = JSON.parse(excelData[i].packagesize)
                  excelData[i].Y = jsP.Y;
                  excelData[i].X = jsP.X;
                  excelData[i].M = jsP.M;
                  excelData[i].C = jsP.C;
                }
              }catch(ex){

              }
            }
            column1=["dname","erpserial","ordernum","buyordernum","feileigoryname","pinpaigoryname","seedname","seedcode","totalnumber","Y","X","M","C","customername","ordername","remark","accdate","cangkuname","uname"];
            header1=["门店","坏件入库单号","销售单号","采购单号","大类","品牌","商品名称","商品编码","数量","球镜","柱镜","规格","型号","责任人","类别","原因","入库日期","仓库","录入人"];
            data=excelData;
            var name = '坏件库-待处理商品';
            this.$exportExcel(header1, column1, data, name)
          })
        } else {
          for (let i in this.tablecolumns) {
            var row = this.tablecolumns[i];
            if (!row.property) continue;
            header1.push(row.className ? row.className : row.label);
            column1.push(row.property);
          }
          for (let i in this.tableData) {
            if (this.tableData[i].status == -1)
              continue;
            if (this.tableData[i].status == 1)
              this.tableData[i].statusname = '待审核';
            else
              this.tableData[i].statusname = '已生效';
            data.push(this.tableData[i]);
          }

          var SelDate = new Date(this.date)
          var name = SelDate.getFullYear() + "年" + (SelDate.getMonth() + 1) + "月" + (this.radio2 == 1 ? '坏件入库单' : '坏件出库单');
          this.$exportExcel(header1, column1, data, name)
        }
      },
      handleDropCommand(command) {
        switch (command){
          case 'lens':
            this.addstoragebad(2);
            break;
          case 'frame':
            this.addstoragebadFrame(2);
            break;
          case 'other':
            this.$refs.AddStorageBadOther.show();
            this.$refs.AddStorageBadOther.initData(2);
            break;
        }
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      //显示商品选择页面
      showGoodDetailSel() {
        this.$refs.JxcgooddetailSel.show()
      },
      //清空商品
      clearSeedCode() {
        this.seedcode = ""
        this.seedname = ""
        this.bindGrid()
      },
      //选择商品之后执行
      afterSelectCode(row) {
        this.seedcode = row.seedcode
        this.seedname = row.seedname
        this.bindGrid()
      },
      getSummariesOrder(param) {
        const {columns, data} = param;
        this.tablecolumns = columns;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '合计';
            return;
          }
          if (!(column.property=='totalnumber'||column.property=='handlenumber')) {
            sums[index] = '';
            return;
          }
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);

          } else {
            sums[index] = '';
          }
        });

        return sums;
      },
      getSummaries(param) {
        const {columns, data} = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '合计';
            return;
          }
          if (index <=2) {
            sums[index] = '';
            return;
          }
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);

          } else {
            sums[index] = '';
          }
        });

        return sums;
      },
      getPackagesize(packagesize) {
        let s = ""
        if (packagesize) {
          let temp = JSON.parse(packagesize)
          if (temp.M) {
            s = temp.M + '-' + temp.C;
          } else {
            s = "S:" + (parseFloat(temp.Y) > 0 ? "+" + temp.Y : temp.Y) + ",C:" + (parseFloat(temp.X) > 0 ? "+" + temp.X : temp.X)
          }
        }
        return s
      },
      handleEditBatch() {
        if (this.multipleSelection.length == 0) {
          this.$message({
            type: 'error',
            message: '请先选择需要处理的品牌？'
          });
          return;
        }
        var categorycode = '';
        var categoryname = '';
        for (let i in this.multipleSelection) {
          categorycode += this.multipleSelection[i].categorycode + ';';
          categoryname += this.multipleSelection[i].categoryname + ';';
        }

        this.$refs.StorageBadEdit.initData({
          categorycode: categorycode,
          seedcode: '',
          cangkucode: this.multipleSelection[0].cangkucode,
          cangkuname: this.multipleSelection[0].cangkuname,
          categoryname: categoryname
        })
      },
      handleEdit(row) {
        this.$refs.StorageBadEdit.initData(row)
      } ,
      addstoragebad(type) {
        this.$refs.AddStorageBad.show()
        this.$refs.AddStorageBad.initData(type)
      },
      addstoragebadFrame(type) {
        this.$refs.AddStorageBadFrame.show()
        this.$refs.AddStorageBadFrame.initData(type)
      },
      lookorder(row) {
        this.$refs.StorageBadDetail.initData(row, this.searchdata,this.date)
      },
      setTableheight() {
        if (this.eltableheight == this.tableHeight(120)) {
          this.eltableheight = this.tableHeight(119);
        } else {
          this.eltableheight = this.tableHeight(120);
        }
      },
      bindGrid(rebindtip) {
        this.tableData = []
        this.multipleSelection = []
        if (!this.date)
          this.setNow();
        var SelDate = new Date(this.date)

        if (this.radio2 == 1) {//入库单
          inorder({
            cangkucode: this.cangkucode,
            search: this.searchdata,
            seedcode: this.seedcode,
            yearflag: SelDate.getFullYear(),
            monthflag: SelDate.getMonth() + 1,
          }).then(response => {
            this.tableData = response.data.obj
            for (let i = 0; i < this.tableData.length; i++) {
              this.tableData[i].packagesize = this.getPackagesize(this.tableData[i].packagesize);
            }
            this.setTableheight()
          }).catch((error) => {
            console.log(error)
          });
        }else  if (this.radio2 == 3) {//出库单
          outorder({
            cangkucode: this.cangkucode,
            search: this.searchdata,
            seedcode: this.seedcode,
            yearflag: SelDate.getFullYear(),
            monthflag: SelDate.getMonth() + 1,
          }).then(response => {
            this.tableData = response.data.obj
            for (let i = 0; i < this.tableData.length; i++) {
              this.tableData[i].packagesize = this.getPackagesize(this.tableData[i].packagesize);
            }
            this.setTableheight()
          }).catch((error) => {
            console.log(error)
          });
        }  else if (this.radio2 == 2) {//待处理
          badpartscount({
            cangkucode: this.cangkucode,
            search: this.searchdata,
            seedcode: this.seedcode
          }).then(response => {
            this.tableData = response.data.obj
            this.setTableheight()
            this.clearZero();
          })
        } else {//已处理汇总
          completedcount({
            cangkucode: this.cangkucode,
            search: this.searchdata,
            seedcode: this.seedcode,
            yearflag: SelDate.getFullYear(),
            monthflag: SelDate.getMonth() + 1,
          }).then(response => {
            this.tableData = response.data.obj
            this.setTableheight()
            this.clearZero();
          })
        }

        if (rebindtip) {
          this.$emit("bindTip")
        }
      },
      //查看订单
      lookdingdan(erpserial) {
        if (!erpserial) return;

        if(erpserial.startsWith('78')){
          this.$refs.BaoSunDetail.show(erpserial,false)
          return;
        }else  if(erpserial.startsWith('79')){
          this.$refs.StorageBadOut1.show(erpserial)
          return;
        }

        var s = {
          erpserial: erpserial
        }
        this.$refs.DataContactEdit.initData(s)
        this.$refs.DataContactEdit.show()
        this.$refs.DataContactEdit.yincangdayin('order')
      },
      clearZero(){
        var colms='tuihuo;zhuanru;yanguang;guike;zhiliang;jiagongbaosun;duofa;ruzhnegshiku;yuanpian;sunhao;guoqi;thgys'.split(';')
        for(let i=0;i<this.tableData.length;i++) {
          for (let j = 0; j < colms.length; j++) {
            if(this.tableData[i][colms[j]]==0)
              this.tableData[i][colms[j]]=null;
          }
        }
      },
      //根据登录人过滤仓库
      cusandptbyind() {
        cusandptbyind({}).then(response => {
          this.jxcstoreData = response.data.obj
          this.cangkucode= this.jxcstoreData[0].cangkucode
          //默认仓库
          if (this.userInfoModel.cangku) {
            let temp1 = this.userInfoModel.cangku.split(";")
            biaoji:
              for (let i in temp1) {
                for (let j in  this.jxcstoreData) {
                  if (temp1[i] == this.jxcstoreData[j].cangkucode) {
                    this.cangkucode = temp1[i]
                    break biaoji;
                  }
                }
              }

          }
          if (this.userInfoModel.independentserial == "") {//总部登录
            this.jxcstoreData.unshift({
              cangkuname: "全部仓库",
              cangkucode: ''
            })
          }
          this.bindGrid();
        })

      },
      setNow(){
        this.date=new Date()
      }
    },
    mounted() {
      this.bimanage=this.$route.query.bimanage?true:false;
      this.userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"))
      //默认值
      this.independentserial = this.userInfoModel.independentserial;
      this.setNow();
      //绑定仓库,绑定列表数据
      this.cusandptbyind()
    },
    components: {
      StorageBadEdit,
      StorageBadDetail,
      AddStorageBad,
      AddStorageBadFrame,
      JxcgooddetailSel,
      AddStorageBadOther,
      BaoSunDetail,
      StorageBadOut,
      CstagreementEdit
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/warehouse/StorageBad.vue